<div class="planStatus-controlContent">
    <div id="Header" class="percent-container">
        <div class="percent-meter">
            <div id="DisplayPercent">
                <div placement="top" [ngbPopover]="headerTooltip" containerClass="planStatusHeaderTooltip"
                    triggers="mouseenter:mouseleave" container="body">
                    <svg viewBox="-18.75 -18.75 37.5 37.5"
                        [ngClass]="{'colorLow': displayPercent <= rangeLow, 'colorNormal': displayPercent < rangeHigh && displayPercent > rangeLow, 'colorHigh': displayPercent >= rangeHigh}">
                        <circle r="18"></circle>
                    </svg>
                    <span>{{displayPercent | number: '1.0-0'}}%</span>
                </div>
            </div>
            <ng-template #headerTooltip>
                <div cvLocalizedText langSection="Plans_Status_Module" langKey="On_Track">On track</div>
            </ng-template>
            <div class="d-flex flex-row justify-content-center displayFraction">{{displayComplete | number:
                '1.0-0'}}/{{displayTotal | number: '1.0-0'}}</div>
        </div>
        <svg *ngIf="!isDashboardProjection" class="icon-20 fill-iconDefault cursor-pointer" style="margin-right: 15px;"
            (click)="openPMPage()">
            <use href="../App_Themes/CXone/icons/new-window.svg#new-window"></use>
        </svg>
    </div>
    <div class="apply-margin d-flex flex-column align-items-center">
        <ng-container *ngTemplateOutlet="multiSelectDropdownTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="tabsTemplate"></ng-container>
    </div>
</div>

<!-- Break Down Chart -->
<div class="gridItemChildModule w-100 d-flex flex-column planStatus-chartContent" *ngIf="viewByStatusBreakDown"
    [class.without-dropdown]="!plansDropdownVisibility" id="stack-chart-body-{{moduleKey}}" #stackChartBody>
    <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
    <div class="row ml-0 mt-3 w-100 justify-content-center" *ngIf="selectedPlans.length > 0">
        <div *ngFor="let item of chartLegends; index as i" [class.strike-line]="item.toggleLegend === true"
            class="p-1 d-flex reduce-top-margin cursor-pointer {{item.className}}" style="align-items: center;"
            (click)="toggleLegend(item)">
            <span class="colors mr-1" id="color-slices">
                <span id="color-slice-{{i}}" class="color"
                    [ngStyle]="{'background': !item.toggleLegend ? item.color : 'rgba(5, 19, 26, 0.48)'}"></span>
            </span>
            <span class="ellipsis-legend" title="{{item.label}}" #legendRef>{{item.label}}
            </span>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="highChartsTemplate; context: {data: { highcharts: highcharts, chartOptions: chartOptions }}"></ng-container>
</div>

<!-- On-Track Status Chart -->
<div class="gridItemChildModule w-100 d-flex flex-column planStatus-chartContent"
    [class.without-dropdown]="!plansDropdownVisibility" *ngIf="!viewByStatusBreakDown">
    <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="highChartsTemplate; context: {data: { highcharts: highchartsOnTrack, chartOptions: chartOptionsOnTrack }}"></ng-container>
</div>

<ng-template #multiSelectDropdownTemplate>
    <cxone-multiselect-dropdown *ngIf="plansDropdownVisibility" [(ngModel)]="manualSelection" [options]="mSelectOptions"
        [label]="'PlanName'" [primaryKey]="'PlanId'" (dropdownClosed)="moduleManager.saveSettings()"
        [maxTagsToDisplay]="3" [maxSelectionLimit]="5" (selectionChanged)="selectionChanged()"
        [maxItemsToDisplay]="1000" class="w-100 px-2 apply-margin-dropdown">
    </cxone-multiselect-dropdown>
</ng-template>

<ng-template #tabsTemplate>
    <div class="w-100 px-2 pt-2 d-flex flex-row justify-content-center">
        <button type="button" class="cxone-btn btn-big btn-secondary btn-bg-is-white"
            [ngClass]="{'buttonActive':!viewByStatusBreakDown}" cvLocalizedText langSection="Plans_Status_Module"
            langKey="On_Track_Status" (click)="setAutoSelect(false)" [disabled]= "manualSelection.length == 0 && !autoSelect">
            On-Track Status
        </button>
        <button type="button" class="cxone-btn btn-big btn-secondary btn-bg-is-white"
            [ngClass]="{'buttonActive':viewByStatusBreakDown}" cvLocalizedText langSection="Plans_Status_Module"
            langKey="Break_Down_Status" (click)="setAutoSelect(true)" [disabled]= "manualSelection.length == 0 && !autoSelect">
            Break Down Status
        </button>
    </div>
</ng-template>

<ng-template #highChartsTemplate let-data="data">
    <ng-container *ngIf="selectedPlans.length > 0">
        <highcharts-chart [Highcharts]="data.highcharts" [options]="data.chartOptions" id="stack-chart"
            (chartInstance)="setChartInstance($event)" style="padding: 5px;"
            class="w-100 h-100 without-dropdown-margin">
        </highcharts-chart>
    </ng-container>
</ng-template>

<ng-template #noDataTemplate>
    <div class="w-100 noDataContainer" #noDataContainer *ngIf="selectedPlans.length === 0 && planStatuses.length > 0">
        <svg class="empty-error-icon">
            <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
        </svg>
        <span cvLocalizedText langSection="Plans_Status_Module" langKey="No_Plans">No Plans Selected</span>
    </div>
    <div class="w-100 noDataContainer" #noDataContainer *ngIf="planStatuses.length === 0">
        <svg class="empty-error-icon">
            <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
        </svg>
        <span cvLocalizedText langSection="Plans_Status_Module" langKey="No_Plans_Data">No data available</span>
    </div>
</ng-template>